import './CallPush.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';

import { imActions, imCallSelector } from '$store/im';
import { useDispatch, useSelector } from 'react-redux';
import { mainSelector } from '$store/main';
import { UnitName, UnitPhoto } from '$shared/components';
import { Button, RoundButton } from '$uikit';
import { IcClock28, IcClose28, IcPhone28 } from '$assets';
import { classNames as cn, statReachGoal } from '$utils';
import { useTranslator } from '$hooks';
import { Helmet } from 'react-helmet';

const audio = new Audio('/sounds/call.mp3');
audio.loop = true;

export const CallPush = () => {
  const { peerId, status } = useSelector(imCallSelector);
  const { users } = useSelector(mainSelector);
  const [display, setDisplay] = useState(false);
  const user = users[peerId];
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleAccept = useCallback(() => {
    dispatch(imActions.callAccept());
    statReachGoal('call_accept', {
      peerId,
    });
  }, []);

  const handleReject = useCallback(() => {
    setDisplay(false);
    setTimeout(() => {
      dispatch(imActions.callReject());
    }, 300);
    statReachGoal('call_reject', {
      peerId,
    });
  }, []);

  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    const defaultFaviconHref = favicon.href;
    let iconFrame = 0;
    const flashIconInterval = setInterval(() => {
      favicon.href = [
        location.origin + '/favicon_call_1.png',
        location.origin + '/favicon_call_2.png',
      ][iconFrame];
      iconFrame++;
      if (iconFrame > 1) {
        iconFrame = 0;
      }
    }, 1000);
    setDisplay(true);

    audio.loop = true;
    audio.currentTime = 0;
    audio.play().catch(() => {
      console.error('audio play error');
    });
    return () => {
      audio.pause();
      clearInterval(flashIconInterval);
      favicon.href = defaultFaviconHref;
    };
  }, []);

  return (
    <div className="CallPush__wrapper">
      <Helmet>
        <title>{t('call_tab_title')}</title>
      </Helmet>
      <div className={cn('CallPush', { display })}>
        <UnitPhoto unit={user} nftIndicator={false} onlineIndicator={false} />
        <div className="CallPush__info">
          <div className="CallPush__info__name">
            <UnitName unit={user} />
          </div>
          <div className="CallPush__info__status">{t('call_push_audio_caption')}</div>
        </div>
        <div className="CallPush__buttons">
          <RoundButton onClick={handleReject} icon={<IcClose28 />} mode="distraction" />
          <RoundButton onClick={handleAccept} icon={<IcPhone28 />} mode="green" />
        </div>
      </div>
    </div>
  );
};
